import React from 'react';

const timeframeOptions = [
  { value: '7d', label: '7 Days' },
  { value: '30d', label: '30 Days' },
  { value: '90d', label: '90 Days' },
  { value: '1y', label: '1 Year' }
];

export default function TimeframeSelector({ 
  value = '30d', 
  onChange, 
  options = timeframeOptions,
  className = '' 
}) {
  return (
    <div className={`timeframe-selector ${className}`} style={{
      display: 'flex',
      gap: '0.5rem',
      padding: '0.25rem',
      backgroundColor: '#F3F4F6',
      borderRadius: '8px',
      border: '1px solid #E5E7EB'
    }}>
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          style={{
            padding: '0.5rem 1rem',
            border: 'none',
            borderRadius: '6px',
            fontSize: '0.875rem',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            backgroundColor: value === option.value ? '#3B82F6' : 'transparent',
            color: value === option.value ? 'white' : '#6B7280'
          }}
          onMouseOver={(e) => {
            if (value !== option.value) {
              e.target.style.backgroundColor = '#E5E7EB';
              e.target.style.color = '#374151';
            }
          }}
          onMouseOut={(e) => {
            if (value !== option.value) {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#6B7280';
            }
          }}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}